import { render, staticRenderFns } from "./ActivityAssigment.vue?vue&type=template&id=fb812a6a&"
import script from "./ActivityAssigment.vue?vue&type=script&lang=js&"
export * from "./ActivityAssigment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports